module.exports = __webpack_public_path__ + "img/AgentOS-Logo.e948a636.png";